import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { ApiError, api, errorMessage } from "../../api/client";
import PostMedia from "../Post/PostMedia";
import logger from "../utils/logger";

function PhotoGrid({ photos }) {
  if (!photos?.length) return null;

  return (
    <>
      {photos.map((photo) => (
        <div key={photo.photo_guid} className="grid-item">
          <PostMedia photo={photo} className="post-media" />
          {photo.description && (
            <p className="photo-caption">{photo.description}</p>
          )}
        </div>
      ))}
    </>
  );
}

export default function SharedPost() {
  const { shareGuid } = useParams();

  logger.log("share guid from within component is", shareGuid);

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    if (!shareGuid) return;

    setLoading(true);
    setError(null);
    setForbidden(false);

    // No auth token required — access is controlled by the SharePostCode validity.
    api
      .get(`/family/api/post/share/${shareGuid}/`)
      .then((data) => {
        logger.log(data);
        setPost(data);
      })
      .catch((err) => {
        if (err instanceof ApiError && err.status === 403) setForbidden(true);
        else if (err instanceof ApiError && err.status === 404)
          setError("not_found");
        else setError(errorMessage(err));
      })
      .finally(() => setLoading(false));
  }, [shareGuid]);

  if (loading) {
    return (
      <div className="status-container">
        <p>Loading…</p>
      </div>
    );
  }

  if (forbidden) {
    return (
      <div className="status-container error">
        <h2>Link Expired</h2>
        <p>This share link is no longer valid. Please ask for a new one.</p>
      </div>
    );
  }

  if (error === "not_found") {
    return (
      <div className="status-container error">
        <h2>Not Found</h2>
        <p>This post doesn't exist or the link is incorrect.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="status-container error">
        <p>{error}</p>
        <p>Something went wrong. Please try again later.</p>
      </div>
    );
  }

  if (!post) return null;

  const authorFirstName = post.member.first_name ?? "Family";
  const authorDisplayName = `${post.member.first_name} ${post.member.last_name}`;

  return (
    <>
      <header className="header">
        <div className="header-content">
          <h1>{authorFirstName}'s Family</h1>
        </div>
      </header>

      <main>
        <div className="grid-item">
          <div className="item-content">
            <h4>
              {authorDisplayName ?? authorFirstName} — {post.tidy_date}
            </h4>
            <h3>{post.title}</h3>
            {/* dangerouslySetInnerHTML mirrors Django's |safe filter.
                Ensure content is sanitised on the backend before using this. */}
            <p dangerouslySetInnerHTML={{ __html: post.content }} />
          </div>
        </div>

        <PhotoGrid photos={post.photo_set} />
      </main>
    </>
  );
}
